import React, { useRef, useState } from 'react'
import DialogModal from 'shared/components/DialogModal'
import PropTypes from 'prop-types'
import AddressBookItem from './AddressBookItem'
import AppList from '@crema/core/AppList'
import AppScrollbar from '@crema/core/AppScrollbar'
import AppSearch from '@crema/core/AppSearchBar'
import { grey } from '@mui/material/colors'
import { Stack } from '@mui/material'

const AddressBookWrapper = ({ open, handleClose, data, onDeleteAddressBook, multiple, id, placeholderSearch, title, jabatan }) => {
    const filterEl = useRef(null);
    const [dataSearchAddressbook, setDataSearchAddressbook] = useState([])

    const handleSearchAddressbook = (value) => {
        let result = []
        if (jabatan) {
            result = data.filter(item => item.nama.toLowerCase().includes(value.toLowerCase()))
        } else {
            result = data.filter(item => item.toLowerCase().includes(value.toLowerCase()))
        }

        if (!value) {
            setDataSearchAddressbook([])
            return
        }

        setDataSearchAddressbook(result)
    }

    return (
        <DialogModal open={open} handleClose={handleClose} size='sm' title={title ? title : 'Berbagi Dengan'}>
            <Stack direction={'column'} spacing={3}>
                <AppSearch
                    iconPosition={'left'}
                    overlap={true}
                    placeholder={placeholderSearch}
                    inputRef={filterEl}
                    onChange={() => {
                        handleSearchAddressbook(filterEl.current?.value)
                    }}
                    sx={{
                        '&.MuiInputBase-root': {
                            width: '100% !important'
                        },
                        '&.MuiInputBase-root .MuiInputBase-input': {
                            backgroundColor: grey[100],
                            width: '100% !important'
                        },
                        '&.MuiInputBase-root .MuiInputBase-input:focus': {
                            width: '240px'
                        }
                    }}
                />
                <AppScrollbar sx={{ height: 350 }}>
                    <AppList
                        data={dataSearchAddressbook.length !== 0 ? dataSearchAddressbook : data}
                        renderRow={(item, index) => (
                            onDeleteAddressBook ? (
                                <AddressBookItem
                                    item={item}
                                    onDeleteAddressBook={() => {
                                        if (multiple && id != '') {
                                            onDeleteAddressBook(item, id)
                                        } else {
                                            onDeleteAddressBook(item)
                                        }
                                        filterEl.current.value = ''
                                        setDataSearchAddressbook([])
                                    }}
                                    index={index}
                                    labelDelete={id ? `Hapus ${id}` : 'Hapus'}
                                    jabatan={jabatan}
                                />
                            ): (
                                <AddressBookItem
                                    item={item}
                                    index={index}
                                    labelDelete={id ? `Hapus ${id}` : 'Hapus'}
                                    jabatan={jabatan}
                                />

                            )
                        )}
                    />
                </AppScrollbar>
            </Stack>
        </DialogModal>
    )
}
AddressBookWrapper.defaultProps = {
    multiple: false,
    id: '',
    jabatan: false
}
AddressBookWrapper.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    data: PropTypes.array,
    onDeleteAddressBook: PropTypes.func,
    multiple: PropTypes.bool,
    id: PropTypes.string,
    placeholderSearch: PropTypes.string,
    title: PropTypes.string,
    jabatan: PropTypes.bool
}

export default AddressBookWrapper
